import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {environment} from "../../environments/environment.prod";
import {Injectable} from "@angular/core";

@Injectable()
export class ExportProvider {

  constructor(public http: HttpClient, public oauthService: OAuthService) {
  }

  apiBase: string = "/main-records/v1/exports/export";

  getExports() {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBase}`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  postExport(exportObj) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiLogin}${this.apiBase}`, exportObj, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  putExport(exportObj) {
    return new Promise((resolve, reject) => {
      this.http.put(`${environment.apiLogin}${this.apiBase}`, exportObj, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  deleteExport(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(`${environment.apiLogin}${this.apiBase}/${id}`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  getExportMappingByExportId(id) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBase}-mapping/${id}`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  getExportMappingByAccountId(id) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBase}-mapping/by-account-plan-id/${id}`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  postExportMapping(obj) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiLogin}${this.apiBase}-mapping`, obj, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  deleteExportMapping(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(`${environment.apiLogin}${this.apiBase}-mapping/${id}`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  postLayout(obj) {
    return new Promise((resolve, reject) => {
      this.http.post(`${environment.apiLogin}${this.apiBase}-layout`, obj, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  getLayouts() {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBase}-layout`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  getLayout(id) {
    return new Promise((resolve, reject) => {
      this.http.get(`${environment.apiLogin}${this.apiBase}-layout/${id}`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  putLayout(obj) {
    return new Promise((resolve, reject) => {
      this.http.put(`${environment.apiLogin}${this.apiBase}-layout`, obj, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }

  deleteLayout(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(`${environment.apiLogin}${this.apiBase}-layout/${id}`, {
        headers: {Authorization: this.oauthService.authorizationHeader()}
      }).subscribe(resolve, reject);
    });
  }
}
